import React, { useEffect, useState, memo } from "react";
import GastronomyCard from "./GastronomyCard";
import API, { graphqlOperation } from "@aws-amplify/api";
import { getGastronomies } from "../services/graphql/gastronomy";
import { GraphQLResult, Gastronomy } from "models";
import Amplify from "@aws-amplify/core";
import Config from "../config";
import GastronomyCardLoader from "./GastronomyCardLoader";
// import * as publicIp from "public-ip";

Amplify.configure({
  Auth: {
    identityPoolId: Config.identityPoolId,
    region: Config.region,
    userPoolId: Config.userPoolId,
    userPoolWebClientId: Config.userPoolWebClientId,
    mandatorySignIn: false,
  },
  API: {
    graphql_endpoint: Config.graphql_endpoint,
    graphql_endpoint_iam_region: Config.region,
  },
});

interface Props {
  description?: React.ReactNode;
  footer?: React.ReactNode;
}

const Gastronomies = ({ description, footer }: Props) => {
  const [gastronomies, setGastronomies] = useState<Gastronomy[]>([]);
  const [coordinates, setCoordinates] = useState<{
    lng: number;
    lat: number;
  } | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const amountOfLoaders: number[] = [1, 2, 3, 4];

  // useEffect(() => {
  //   const fetchCoordinates = async () => {
  //     try {
  //       const ip = await publicIp.v4();

  //       if (ip) {
  //         const response = await fetch(
  //           `http://api.ipstack.com/${ip}?access_key=${Config.api_stack_key}`
  //         );

  //         if (response) {
  //           const json = await response.json();

  //           if (json.latitude && json.longitude) {
  //             setCoordinates({ lat: json.latitude, lng: json.longitude });
  //           }
  //         }
  //       }
  //     } catch (error) {
  //       console.error(error);
  //     }
  //   };

  //   if (!coordinates) {
  //     fetchCoordinates();
  //   }
  // }, []);

  useEffect(() => {
    const fetchGastronomies = async () => {
      setLoading(true);
      try {
        const params: any = {};

        if (coordinates) {
          params.source_lat = coordinates.lat;
          params.source_lng = coordinates.lng;
          params.distance_in_km = 20;
        }

        const { data } = (await API.graphql(
          graphqlOperation(getGastronomies, {
            params,
          })
        )) as GraphQLResult<{ getGastronomies: Gastronomy[] | null }>;

        if (data && data.getGastronomies) {
          setGastronomies(data.getGastronomies);
        }
      } catch (error) {
        console.error(error);
      }
      setLoading(false);
    };

    fetchGastronomies();
  }, [coordinates]);

  return (
    <section className="bg-white py-8">
      <div className="container max-w-5xl mx-auto m-8">
        <h2 className="w-full my-2 text-5xl font-bold leading-tight text-center text-gray-800">
          Partner-Restaurants
        </h2>
        <div className="w-full mb-4">
          <div className="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t" />
        </div>

        {description}

        <div className="flex justify-start align-center overflow-x-auto">
          {loading ? (
            <React.Fragment>
              {amountOfLoaders.map((i) => (
                <GastronomyCardLoader key={i} />
              ))}
            </React.Fragment>
          ) : (
            <React.Fragment>
              {gastronomies.map((g) => (
                <GastronomyCard gastronomy={g} key={g.uuid} />
              ))}
            </React.Fragment>
          )}
        </div>

        {footer}
      </div>
    </section>
  );
};

export default memo(Gastronomies);
